export const userColumns = '1.5fr 2fr 1fr 1.5fr 1fr'

export const PAGE_LIMIT = 20
